import { css } from '@portal/styled-system/css'

import { useI18n } from '@/shared/lib/i18n'
import { Button, CancelButton, ErrorMessage, Modal, type ModalProps, TextArea } from '@/shared/ui'
import { EmailInput } from '@/shared/ui/input-v2/email'
import { Input } from '@/shared/ui/input-v2/view'

export type SupportDialogProps = ModalProps & {
    onFormSubmit: (data: FormData) => void
    onFormChange: () => void
    isEmailError: boolean
    isNickError: boolean
    isDescriptionError: boolean
    defaultEmail?: string
    defaultNick?: string
    nonInteractive?: boolean
}

export function SupportDialog(props: SupportDialogProps) {
    const { i18n } = useI18n()

    return (
        <Modal {...props}>
            <Modal.CloseButton onClose={props.onClose} />
            <Modal.Header styles={css.raw({ backgroundColor: 'primary' })} icon="fa-solid fa-messages-question">
                {i18n.PORTAL_SUPPORT}
            </Modal.Header>
            <Modal.Body>
                <form
                    method="post"
                    className={css({ width: 'full', display: 'flex', flexDirection: 'column', gap: '3' })}
                    onInput={props.onFormChange}
                    onSubmit={(e) => {
                        e.preventDefault()
                        props.onFormSubmit(new FormData(e.currentTarget))
                    }}
                >
                    <EmailInput
                        id="support-email"
                        placeholder={i18n.PLACEHOLDER_YOUR_EMAIL}
                        defaultValue={props.defaultEmail}
                        isDisabled={props.nonInteractive}
                        isError={props.isEmailError}
                        description={props.isEmailError ? i18n.TEXT_ERROR_EMAIL_INVALID : undefined}
                    />
                    <Input
                        id="support-name"
                        type="name"
                        name="nick"
                        placeholder={i18n.PLACEHOLDER_YOUR_NAME}
                        required
                        defaultValue={props.defaultNick}
                        isDisabled={props.nonInteractive}
                        isError={props.isNickError}
                        description={props.isNickError ? i18n.TEXT_ERROR_NICK_INVALID : undefined}
                    />
                    <TextArea
                        id="support-message"
                        name="description"
                        rows={9}
                        placeholder={i18n.PLACEHOLDER_SUPPORT_MESSAGE}
                        required
                        isDisabled={props.nonInteractive}
                    />
                    {props.isDescriptionError && (
                        <ErrorMessage styles={css.raw({ fontSize: 'sm', mt: '-2' })}>
                            {/* TODO завести более понятную строку */}
                            {i18n.TEXT_ERROR_FORM_NOT_SUBMITTED}
                        </ErrorMessage>
                    )}
                    <Modal.Buttons styles={css.raw({ justifyContent: 'flex-end', gap: '2', padding: '0', pt: '0' })}>
                        <CancelButton
                            onPress={props.onClose}
                            isDisabled={props.nonInteractive}
                            styles={css.raw({ width: 'auto' })}
                        />
                        <Button
                            type="submit"
                            color="success"
                            styles={css.raw({ width: 'auto' })}
                            isDisabled={props.nonInteractive}
                        >
                            {i18n.BUTTON_SEND_REQUEST}
                        </Button>
                    </Modal.Buttons>
                </form>
            </Modal.Body>
        </Modal>
    )
}
